/*
 * Application Insights JavaScript SDK - Common, 2.7.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
export var RequestHeaders = {
  requestContextHeader: "Request-Context",
  requestContextTargetKey: "appId",
  requestContextAppIdFormat: "appId=cid-v1:",
  requestIdHeader: "Request-Id",
  traceParentHeader: "traceparent",
  traceStateHeader: "tracestate",
  sdkContextHeader: "Sdk-Context",
  sdkContextHeaderAppIdRequest: "appId",
  requestContextHeaderLowerCase: "request-context"
};